import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { trackPage } from '../utils/analytics';
const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/4KkPS6djUQM?rel=0&modestbranding=1';
const CTA_URL = `https://api.whatsapp.com/send?phone=525637543320&text=${encodeURIComponent('Hola, me interesa acceder a la Academia de Bienes Raíces...')}`;
export function Academia() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackPage('/academia');
  }, []);
  return <div className="min-h-screen bg-black font-sans text-white flex flex-col" data-id="element-234" data-mp="1al3rrsav8cap">
      <main className="flex-1 w-full max-w-5xl mx-auto px-4 pt-10 pb-16 md:pt-14" data-id="element-235" data-mp="wtp5nclnvuzf">
        {/* HEADLINE */}
        <motion.header initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-8 md:mb-12" data-id="element-236" data-mp="10rd6sxdy6jzr">
          <h1 className="font-sans text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold uppercase leading-tight" data-id="element-237" data-mp="1mk6hm6f5afvk">
            Como Construir Multiples Fuentes de Ingreso en Bienes Raíces
          </h1>
          <p className="mt-2 text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-gold-metallic" data-id="element-238" data-mp="1vjtnp5itk9uy">
            Masterclass Gratuita
          </p>
        </motion.header>

        {/* VIDEO */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full aspect-video overflow-hidden rounded-lg ring-1 ring-white/10 bg-black" data-id="element-239" data-mp="13tp2j4n8jiso">
          <iframe src={YOUTUBE_EMBED_URL} title="Masterclass: Cómo Construir Múltiples Fuentes de Ingreso en Bienes Raíces" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="absolute inset-0 w-full h-full border-0" data-id="element-240" data-mp="k4eqq1qm1hzu" />
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 md:mt-10" data-id="element-241" data-mp="2yvsfsxp1n8mo">
          <a href={CTA_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPage('academia_whatsapp_click')} className="block w-full text-center bg-[#E5A82E] hover:bg-[#D19A25] text-white font-bold text-sm sm:text-base md:text-lg py-4 md:py-5 px-6 rounded-full shadow-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-metallic focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-242" data-mp="2f8319s64b4ve">
            Da clic aquí para Acceder Ahora a la Academia de Bienes Raíces
          </a>
        </motion.div>
      </main>

      {/* FOOTER */}
      <footer className="w-full border-t border-white/10" data-id="element-243" data-mp="11885oftb1r7p">
        <div className="max-w-5xl mx-auto px-4 py-8 md:py-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-center md:text-left" data-id="element-244" data-mp="w9wykcue9ut6">
          <div data-id="element-245" data-mp="r98wmw4mntk6">
            <p className="text-lg md:text-2xl font-bold" data-id="element-246" data-mp="rcobpyyax2ll">
              Bienes Raíces Academy
            </p>
            <p className="text-sm md:text-lg text-white/80" data-id="element-247" data-mp="i9vllz0uuwxc">
              Por Susana Sánchez G
            </p>
          </div>

          <div className="text-center leading-tight" data-id="element-248" data-mp="2hnj5hfih64gs">
            <p className="text-base md:text-xl font-bold tracking-[0.15em] text-white" data-id="element-249" data-mp="2hkx09mj2411q">
              ACADEMIA
            </p>
            <p className="text-lg md:text-2xl font-extrabold tracking-wide text-gold-metallic" data-id="element-250" data-mp="19d8ys77q5n6u">
              BIENES RAÍCES
            </p>
          </div>

          <p className="text-xs text-white/60 md:text-right" data-id="element-251" data-mp="1ebat5oalp8xm">
            Todos los Derechos Reservados
            <br data-id="element-252" data-mp="10c1fav9vaqwt" />
            2026
          </p>
        </div>
      </footer>
    </div>;
}